import React from 'react';
import emptySearchQuery from 'assets/images/empty-search-query.svg';
import emptySearchResults from 'assets/images/empty-search-results.svg';
import { useIntl } from 'react-intl';
import Heading from '@atlaskit/heading/heading';
import { Stack } from '@atlaskit/primitives/stack';
import { Text } from '@atlaskit/primitives/text';
import { ExperienceSuccess } from '@atlassian/ufo/experience-success';
import { Img } from '../common';
import { searchExperience } from '../experiences';
import messages from './messages';

export interface Props {
	term: string;
}

export const SearchResultNone = ({ term }: Props) => {
	const { formatMessage } = useIntl();

	if (term === '') {
		return (
			<Stack space="space.100" alignInline="center">
				<Img src={emptySearchQuery} alt="" />
				<Heading as="h2" size="xsmall">
					{formatMessage(messages.noSearchQueryTitle)}
				</Heading>
				<Text align="center">{formatMessage(messages.noSearchQueryBody)}</Text>
				<ExperienceSuccess experience={searchExperience} />
			</Stack>
		);
	}

	return (
		<Stack space="space.100" alignInline="center">
			<Img src={emptySearchResults} alt="" />
			<Heading as="h2" size="xsmall">
				{formatMessage(messages.noSearchResultTitle)}
			</Heading>
			<Text align="center">{formatMessage(messages.noSearchResultBody)}</Text>
			<ExperienceSuccess experience={searchExperience} />
		</Stack>
	);
};
